
import axios from '../config/axios';

export const url = '/api/contactdata'


export const createcontactdata = ({
  token,
	namecontact,
	emailcontact,
	messageinfo,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && namecontact && emailcontact ) {

    axios.post(`${url}//create/basic/68c49adcd9a58bc9adfd0d5b`, {
		namecontact,
		emailcontact,
		messageinfo,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!namecontact) {
		reject({
			status: 'error',
			info: 'Nombre no esta definido',
		});
	}  else if (!emailcontact) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

